import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useCallback,
  useState,
} from "react";
import { useUser } from "contexts/UserContext";
import querySchedule from "../../../../services/scheduler/querySchedule";

type Context = {
  schedule: Schedule;
  setSchedule: React.Dispatch<React.SetStateAction<Schedule>>;
  busy: boolean;
  forceReload: () => void;
};
const ScheduleContext = createContext<Context>({
  schedule: [],
  setSchedule: () => null,
  busy: true,
  forceReload: () => null,
});

type Props = { children: ReactNode };

export const ScheduleContextProvider = ({ children }: Props) => {
  const { user } = useUser();
  const [schedule, setSchedule] = useState<Schedule>([]);
  const [busy, setBusy] = useState(true);
  const [reload, setReload] = useState(0);
  const forceReload = useCallback(() => setReload((s) => s + 1), []);

  // get schedule on init
  useEffect(() => {
    if (!user) {
      return;
    }
    setBusy(true);
    querySchedule()
      .then(setSchedule)
      .catch(console.error)
      .finally(() => setBusy(false));
  }, [user, reload]);

  return (
    <ScheduleContext.Provider
      value={{
        schedule,
        setSchedule,
        busy,
        forceReload,
      }}
    >
      {children}
    </ScheduleContext.Provider>
  );
};

export const useSchedule = () => useContext(ScheduleContext);
